var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2761_3728)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#062C5B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4998 26.5002C18.4299 26.5002 19.9996 24.9306 19.9996 23.0004V14.1241L27.8741 16.9869V23.4878C27.3446 23.1723 26.7405 23.0041 26.1242 23.0004C24.194 23.0004 22.6244 24.5701 22.6244 26.5002C22.6244 28.4303 24.194 30 26.1242 30C28.0543 30 29.6239 28.4303 29.6239 26.5002V16.3745C29.6241 16.195 29.5689 16.0198 29.4659 15.8728C29.3628 15.7258 29.217 15.6141 29.0482 15.5529L19.4238 12.0531C19.2917 12.0048 19.1499 11.9891 19.0104 12.0074C18.8709 12.0256 18.7379 12.0773 18.6226 12.1579C18.5074 12.2386 18.4133 12.3458 18.3483 12.4706C18.2834 12.5954 18.2496 12.734 18.2497 12.8747V19.988C17.7202 19.6726 17.1161 19.5043 16.4998 19.5007C14.5697 19.5007 13 21.0703 13 23.0004C13 24.9306 14.5697 26.5002 16.4998 26.5002Z",
    fill: "#4C7EBD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2761_3728",
    x: -4,
    y: -4,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2761_3728"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2761_3728",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup6);
export default __webpack_public_path__ + "static/media/Group6.7adebe8808d5568b66f199c9b8a7f3e3.svg";
export { ForwardRef as ReactComponent };